import React from 'react'
import PropTypes from 'prop-types'
import Waypoint from 'react-waypoint'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import styles from './_hero.css'

function YearInReviewHero (props) {
  const {
    activateStatCard,
    activeCards,
    id,
    showProfileImage,
    username,
    location,
    isLoggedIn,
    userCountry,
    hideWaypoint,
    year,
  } = props
  const isActive = activeCards.includes(id)
  const activeClass = isActive ? styles.active : styles.inactive
  const loggedInClass = isLoggedIn ? '' : styles.loggedOut
  const showSponsor = userCountry === 'US'

  return (
    <div className={`${styles.heroWrapper} ${styles[location]} ${activeClass} ${loggedInClass}`}>
      <div className={styles.hero}>
        <div className={styles.heroBackground}>
          <div className={styles.twenty} />
          <div className={styles.seventeen} />
        </div>
        { showProfileImage ?
          <div className={styles.heroProfile}>
            <img src={`/profile/${username}/picture?size=Medium`} />
          </div>
        : null}
        <div className={styles.heroLogo}>
          <svg>
            <use xlinkHref='#mmf-logo' />
          </svg>
        </div>
        <div className={styles.heroMessage}>
          <FormattedMessage
            id='yearInReview.2017.hero.message'
            defaultMessage={`{ year } \n Year In Review`}
            values={ { year } }
          />
        </div>
        { showSponsor ?
          <div className={styles.heroSponsor}>
            <FormattedHTMLMessage
              id='yearInReview.2017.hero.sponsored'
              defaultMessage='Sponsored By <svg height="50" width="200"><use xlink:href="#afi-logo" /></svg>'
            />
          </div>
        : null }
      </div>
      { hideWaypoint ? null :
        <div className={styles.waypoint}>
          <Waypoint onEnter={ () => { if (!isActive) { activateStatCard(id) } } } bottomOffset="-70px" />
        </div>
      }
    </div>
  )
}

YearInReviewHero.propTypes = {
  activateStatCard: PropTypes.func.isRequired,
  activeCards: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  showProfileImage: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  hideWaypoint: PropTypes.bool,
  username: PropTypes.string,
  userCountry: PropTypes.string,
  location: PropTypes.string,
  year: PropTypes.string,
}

export default YearInReviewHero



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Hero/Hero.jsx